import useThemeHook from "../../hooks/useThemeHook";
import { THEME_COLORS } from "../../themes/DarkLight";

const Skipper = ({
  icon,
  onClick,
  backgroundColor,
}: {
  backgroundColor: string | undefined;
  icon: string;
  onClick: Function;
}) => {
  const theme: "dark" | "light" = useThemeHook();

  return (
    <div onClick={() => onClick()}>
      <div
        style={{
          backgroundColor: backgroundColor ?? THEME_COLORS[theme].less_theme,
          padding: "10px",
          height: "50px",
          width: "60px",
          borderRadius: "10px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontWeight: "500",
        }}
      >
        {icon}
      </div>
    </div>
  );
};

export default Skipper;
